import { HIDE_TOAST, showSuccessToast, showToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import type { ThunkDispatchCommon } from "single-spa/store/types";

export const exportToExcelToastThunk = (text: string, tag?: string) => {
    return (dispatch: ThunkDispatchCommon) => {
        const timestamp = Date.now();
        const content = getToastItemComponent({
            text,
            onClick: () =>
                dispatch({
                    type: HIDE_TOAST,
                    toast: { timestamp },
                }),
        });

        if (tag) {
            dispatch(showSuccessToast(content, timestamp, undefined, undefined, tag));
        } else {
            dispatch(showToast(content, "success", timestamp));
        }
    };
};
